import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { userActions } from '../../data/actions/user';
import { smoothlyMenu } from '../layouts/Helpers';
import FilterButton from '../widgets/filter/FilterButton';
import Filter from '../widgets/filter/Filter';
import profile from '../../../public/img/default-user.png';
import NotificationCount from '../widgets/notifications/NotificationCount'
import NotificationMenu from '../widgets/notifications/NotificationMenu'
import WithPermission from '../../helpers/WithPermission';
import SearchWidget from '../pages/home/SearchWidget'
import { withRouter } from 'react-router';
import ChangelogLink from '../widgets/changelog/ChangelogLink';
import Changelog from '../widgets/changelog/Changelog';
import store from '../../helpers/store';


import moment from 'moment';
import { notificationsActions } from '../../data/actions/notifications';
import DropdownMenu from './DropdownMenu';
const DATE_FORMAT = 'YYYY-MM-DD';

var logoutSvg = require('!svg-inline-loader!../../../public/img/logout.svg');
var adminSvg = require('!svg-inline-loader!../../../public/img/manage.svg');
var arrowDownSvg = require('!svg-inline-loader!../../../public/img/arrow-down.svg');
var worldMapSvg = require('!svg-inline-loader!../../../public/img/world-map.svg');
var homeSvg = require('!svg-inline-loader!../../../public/img/home-icon.svg');
var comparisonSvg = require('!svg-inline-loader!../../../public/img/comparison-icon.svg')
var shareSvg = require('!svg-inline-loader!../../../public/img/share.svg')

class TopHeader extends React.Component {

    constructor(props){
        super(props);
        this.logout = this.logout.bind(this);
    }

    state = {
        todayDate: moment(new Date()).format(DATE_FORMAT)
    }

    componentDidMount() {
      this.props.getCountOfNotifications(this.state.todayDate);
      const lastNotificationID = store.get('lastNotificationID') || 0;
      this.props.getChangelog(lastNotificationID);
    }

    componentDidUpdate(prevProps){
      if(this.props.notifications.count !== prevProps.notifications.count){
        this.props.getCountOfNotifications(this.state.todayDate);
      }
    }

    logout(e){
        e.preventDefault();
        return this.props.logout();
    }

    toggleNavigation(e) {
        e.preventDefault();
        $("body").toggleClass("mini-navbar");
        smoothlyMenu();
        if($("body").hasClass('mini-navbar')) {
          setTimeout(function(e) {
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return false;
          }, 300);
        }
    }

    onUpdatePlaylistNotification = () => {
      const { getPlaylistNotifications, updatePlaylistNotifications } = this.props;
      const { playlist } = this.props.notifications;

      updatePlaylistNotifications(playlist.id, getPlaylistNotifications, this.state.todayDate);
    }

    onUpdateReleaseNotifications = () => {
      const { updateReleaseNotifications, history } = this.props;
      const { releases } = this.props.notifications;

      updateReleaseNotifications(releases.id, this.state.todayDate);

      history.push('/reporting/new-releases');
    }

    onUpdateHeartbeatsNotifications = () => {
      const { updateHeartbeatsNotifications, history } = this.props;
      const { heartbeats } = this.props.notifications;

      updateHeartbeatsNotifications(heartbeats.id, this.state.todayDate);

      history.push('/reporting/heartbeats');
    }
    
    render() {
      const { user, notifications = {}, readonly = false, isTerritories, isImport, globalFilterMode } = this.props,
          userName = user.loggedIn ? `${user.user.first_name} ${user.user.last_name}` : 'Anonymous User',
          userAvatar = user.loggedIn ? (user.user.avatar_url ? user.user.avatar_url : profile) : '',
          isComparison = globalFilterMode == 'comparison', 
          changelogCount = notifications.changelogCount || 0,
          changelogLoading = notifications.changelogLoading || false;
      const hasChangelogBadge = !changelogLoading && changelogCount > 0;;

      const extraHeaderClass = isTerritories || isImport || isComparison ? "no-search-header" : "";

      const dropdownHeader = <div className="dropdown-toggle user-dropdown">
        <div className="user-image-holder">
          {hasChangelogBadge && <span className="user-image-badge">{changelogCount}</span>}
          <div className="user-image-block">
            <img src={userAvatar} alt="profile" title={userName}/>
          </div>
        </div>
        <span className="caret" dangerouslySetInnerHTML={{__html: arrowDownSvg}}></span>
      </div>
            
        return (
          <React.Fragment>
            <div className={`header-container ${extraHeaderClass}`}>
                <nav className="header-navbar" role="navigation">
                    {!readonly && 
                      <div className="header-left-holder">
                        <Link to="/"><div className="main-logo"></div></Link>
                      </div>
                    }
                    {this.props.children}
                    <div className="user-nav">
                      <DropdownMenu header={dropdownHeader}>
                        <ul className="user-dropdown-list">
                          <li>
                            <div className='main-nav-link'>
                              <span className="menu-nav-label">
                                {userName}
                              </span>
                            </div>
                          </li>
                          <ChangelogLink />
                          <Changelog />
                          { (isTerritories || isImport || isComparison) && <li>
                            <Link to={`/main`} className="main-nav-link">
                              <span className="menu-nav-icon" dangerouslySetInnerHTML={{__html: homeSvg}}></span>
                              <span className="menu-nav-label">Main Dashboard</span>
                            </Link>
                          </li>}
                          { !isTerritories && <li>
                              <Link to="/territories" className='main-nav-link'>
                                <span className="menu-nav-icon" dangerouslySetInnerHTML={{__html: worldMapSvg}}></span>
                                <span className="menu-nav-label">Territory Dashboard</span>
                              </Link>
                            </li>
                            }
                          { !isComparison && <li>
                            <Link to="/comparison" className='main-nav-link'>
                              <span className="menu-nav-icon" dangerouslySetInnerHTML={{__html: comparisonSvg}}></span>
                              <span className="menu-nav-label">Comparison</span>
                            </Link>
                          </li>
                          }
  
                          {!readonly && !isImport  && <WithPermission permission="allow_admin">
                            <li>
                              <Link to="/import/statement-periods" className="main-nav-link" > 
                                  <span className="menu-nav-icon" dangerouslySetInnerHTML={{__html: adminSvg}}></span>
                                  <span className="menu-nav-label">Admin</span>
                              </Link>
                            </li>
                          </WithPermission>}
                          <li>
                              <Link to="/user/shared-pages" className='main-nav-link'>
                                <span className="menu-nav-icon" dangerouslySetInnerHTML={{__html: shareSvg}}></span>
                                <span className="menu-nav-label">Shared Pages</span>
                              </Link>
                            </li>
                          {!readonly && <li><a className="main-nav-link logout-link" onClick={this.logout}> 
                              <span className="menu-nav-icon" dangerouslySetInnerHTML={{__html: logoutSvg}}></span>
                              <span className="menu-nav-label">Logout</span>
                              
                          </a></li>}
                        </ul>
                      </DropdownMenu>

                    </div>    
                    {/* {!readonly && !isTerritories && <WithPermission permission="allow_admin">
                        <Link className="admin-link" to="/import/statement-periods"> 
                            <span className="small-icon" dangerouslySetInnerHTML={{__html: adminSvg}}></span>
                            Admin
                        </Link>
                    </WithPermission>}
                    {!readonly && <a className="logout-link" onClick={this.logout}> 
                        <span className="small-icon" dangerouslySetInnerHTML={{__html: logoutSvg}}></span>
                        Logout
                    </a>} */}
                </nav>
            </div>
            {!isTerritories && !isImport ? <div className="main-filter-container">
              <Filter readonly={readonly} globalFilterMode={globalFilterMode} />
            </div> : null}
          </React.Fragment>
        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        notifications: state.notifications,
        catalogueExceptions: state.catalogueExceptions,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        logout: () => dispatch(userActions.logout()),
        getCountOfNotifications: date => dispatch( notificationsActions.getCountOfNotifications(date)),
        updatePlaylistNotifications: (id, cb, date) => dispatch( notificationsActions.updateStorePlaylistNotifications(id, cb, date)),
        updateReleaseNotifications: (id, date) => dispatch( notificationsActions.updateReleaseNotifications(id, date)),
        updateHeartbeatsNotifications: (id, date) => dispatch( notificationsActions.updateHeartbeatsNotifications(id, date)),
        getChangelog: id => dispatch( notificationsActions.getChangelog(id))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TopHeader));
